import React from 'react';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import ContactSection from '../components/ContactSection';

const Contact = () => {
  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation({ threshold: 0.3 });

  return (
    <>
      <Helmet>
        <title>Contact Us | Book Free Automation Audit | Rishant Technologies</title>
        <meta name="description" content="Contact Rishant Technologies for a free automation audit. Get started with AI automation for your business." />
        <link rel="canonical" href="https://rishant.tech/contact" />
      </Helmet>

      <main style={{ paddingTop: '80px' }}>
        {/* Header */}
        <section ref={headerRef} style={{ backgroundColor: '#F5F0E8', padding: 'clamp(4rem, 8vw, 6rem) 1.5rem' }}>
          <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={headerVisible ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, ease: 'easeOut' }}
              style={{ maxWidth: '600px' }}
            >
              <h1 style={{
                fontSize: 'clamp(2.5rem, 5vw, 4rem)',
                fontWeight: 700,
                lineHeight: 1.08,
                letterSpacing: '-0.03em',
                color: '#1A1A1A',
                fontFamily: '"DM Sans", sans-serif',
                marginBottom: '1rem',
              }}>
                Ready to{' '}
                <span style={{ textDecoration: 'underline', textDecorationThickness: '3px', textUnderlineOffset: '6px' }}>
                  automate
                </span>
                {' '}your business?
              </h1>
              <p style={{
                fontSize: '1.1rem',
                lineHeight: 1.7,
                color: '#666666',
                fontFamily: '"DM Sans", sans-serif',
              }}>
                Book a free 20-minute automation audit. No sales pitch. No obligation. Just clarity on what can be automated.
              </p>
            </motion.div>
          </div>
        </section>

        {/* Contact Form + FAQ (rendered by ContactSection component) */}
        <ContactSection />
      </main>
    </>
  );
};

export default Contact;
